if (!customElements.get('search-modal')) {
  customElements.define(
    'search-modal',
    class SearchModal extends HTMLElement {

      constructor() {
        super();

        this.fieldRule = this.querySelector('.animated-field-rule');
        this.input = this.querySelector('input[type="search"]');
        this.addEventListener('keyup', this.onKeyUp.bind(this));
      }

      onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.closeModal()
      }

      openModal() {
        this.classList.add('open');

        gsap.to(this, { opacity: 1, duration: 0.5, ease: 'expo.inOut' });
        gsap.to(this.fieldRule, { width: '100%', duration: 0.6, ease: 'expo.inOut', delay: 0.3 });
        this.input.focus();
      }

      closeModal() {
        this.classList.remove('open');

        gsap.to(this, { opacity: 0, duration: 1, ease: 'expo.inOut' });
        gsap.to(this.fieldRule, { width: '0', duration: 0.6, ease: 'expo.inOut' });
      }
    }
  );
}
